// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --navigation-height: 56px;
}

.Navigation {
    display: block;
    background-color: #8412a1;
    top: 0px;
    position: sticky;
    transform: translateY(0px);
    z-index: 500;
    width: 100%;
    box-shadow:  0px 3px 1px #00000040;
    height: var(--navigation-height);
}

.Logo {
    padding: 3px;
    display: flex;
    height: 100%;
    width: fit-content;
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;IAChB,0BAA0B;IAC1B,YAAY;IACZ,WAAW;IACX,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":[":root {\n    --navigation-height: 56px;\n}\n\n.Navigation {\n    display: block;\n    background-color: #8412a1;\n    top: 0px;\n    position: sticky;\n    transform: translateY(0px);\n    z-index: 500;\n    width: 100%;\n    box-shadow:  0px 3px 1px #00000040;\n    height: var(--navigation-height);\n}\n\n.Logo {\n    padding: 3px;\n    display: flex;\n    height: 100%;\n    width: fit-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
